import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson fonda la London Rubber Company e vende preservativi e accessori da barbiere importati.',
		},
		{
			year: 1929,
			description: 'Durex lancia il suo primo preservativo inumidito.',
		},
		{
			year: 'Anni \'50',
			description: 'Durex lancia il suo primo preservativo inumidito.',
		},
		{
			year: 1953,
			description: 'Durex è il primo marchio a sviluppare e utilizzare test elettronici sui preservativi.',
		},
		{
			year: 'Anni \'60',
			description: 'Durex lancia il primo preservativo con forma anatomica.',
		},
		{
			year: 'Anni \'70',
			description: 'Durex è il primo marchio di preservativi al mondo ad essere pubblicizzato in molti paesi.',
		},
		{
			year: 'Anni \'90',
			description: 'Durex è il primo marchio di preservativi che adotta un "sigillo di qualità" globale come standard.',
		},
		{
			year: 1995,
			description: 'Durex lancia una gamma di preservativi colorati e aromatizzati.',
		},
		{
			year: 1996,
			description: 'Durex è il primo marchio di preservativi a creare un sito Web. Ora ha 42 diversi siti Web nei paesi in cui è commercializzato.',
		},
		{
			year: 1997,
			description: 'Durex lancia i preservativi senza lattice. Per il nuovo prodotto viene utilizzato un nuovo materiale anallergico: il poliuretano sintetico sviluppato da Durex è più morbido ed elastico del lattice di gomma naturale della gamma Durex.',
		},
		{
			year: 1998,
			description: 'Durex è il primo marchio di preservativi a condurre e pubblicare un sondaggio mondiale sul benessere sessuale.',
		},
		{
			year: 2001,
			description: 'Durex lancia Pleasuremax, diventando il primo marchio di preservativi a commercializzare un preservativo che presenta sia rilievi che nervature.',
		},
		{
			year: 2003,
			description: 'Durex lancia la stimolante gamma di gel lubrificanti Play.',
		},
		{
			year: 2005,
			description: 'Durex Network lancia i report “Face of Global Sex”, che esplorano aspetti del comportamento sessuale e vengono creati per l\'informare accademici e responsabili politici.',
		},
		{
			year: 2008,
			description: 'Per promuovere il sesso sicuro tra i giovani, Durex incoraggia i giovani di età compresa tra 16 e 24 anni a creare un poster unico sulla salute sessuale - un poster fatto dagli adolescenti per gli adolescenti.',
		},
		{
			year: 2009,
			description: 'Durex compie 80 anni!',
		},
		{
			year: 2010,
			description: 'Durex sostiene l\'iniziativa "Condomize!" del Fondo delle Nazioni Unite per la popolazione alla Conferenza internazionale sull\'AIDS a Vienna con una donazione di 220.000 preservativi.',
		},
		{
			year: 2010,
			description: 'Durex viene acquisita da Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Durex introduce Intense, un profilattico progettato per aiutare a raggiungere l\'orgasmo insieme. Grazie al rivestimento interno contenente benzocaina al 5% e alla struttura esterna stimolante, può aiutare a prolungare e rendere più intenso il piacere.',
		},
		{
			year: 2019,
			description: 'Durex compie 90 anni!',
		},
		{
			year: 2022,
			description: 'Durex introduce la sua nuova brand identity',
		},
	]
}